import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
import { Divider, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as React from "react";
import CustomerPopupForm from "./CustomerPopupForm";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "80vh",
  width: "60vw",
  bgcolor: "background.paper",
  borderRadius: "15px",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
};

export default function CustomerPopupModal({
  open,
  handleClose,
  document = {},
  onSave,
  setError,
}) {
  return (
    <Modal
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      className={"backdrop-model"}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2,
              py: 2,
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6" sx={{ ml: "1.5rem" }}>
              Walk-in customer
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider />
          <CustomerPopupForm
            initialData={document}
            onClose={handleClose}
            onSave={onSave}
            onSetError={setError}
          />
        </Box>
      </Fade>
    </Modal>
  );
}
